import { CheckCircle2, CircleDashed } from "lucide-react";
import { LiveZoya } from "@/components/LiveZoya";
import { useLang } from "@/context/LanguageContext";
import { fmtClock } from "@/lib/classroom_live";

// Teacher cam beside the lesson: Zoya Ma'am moves, blinks and glows while she is speaking.
export const TeacherCam = ({ lesson, speaking, levelRef, playing, presence, first }) => {
  const { L } = useLang();
  return (
    <div className="rounded-3xl overflow-hidden border border-slate-200 bg-white shadow-[0_20px_50px_-30px_rgba(10,25,47,0.4)] flex lg:block" data-testid="teacher-cam">
      <div className="relative w-32 sm:w-44 lg:w-auto shrink-0 overflow-hidden">
        <LiveZoya src={lesson.teacher} speaking={speaking} levelRef={levelRef} className="w-full h-full !aspect-auto lg:!aspect-[4/3]" testid="teacher-cam-zoya" />
        <span className="absolute top-2 left-2 lg:top-3 lg:left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/90 text-[#0A192F] text-[10px] font-extrabold uppercase tracking-widest shadow">
          <span className={`w-2 h-2 rounded-full ${playing ? "bg-[#FF2E63] animate-pulse" : "bg-slate-400"}`} />{playing ? L("In class", "क्लास जारी") : L("Paused", "रुकी है")}
        </span>
      </div>
      <div className="p-3 sm:p-4 min-w-0 flex-1">
        <div className="flex items-center justify-between gap-2">
          <div className="font-extrabold">Zoya Ma'am</div>
          {first && <div className="text-xs text-slate-500 truncate" data-testid="teacher-cam-student">{L(`Student: ${first}`, `छात्र: ${first}`)}</div>}
        </div>
        <div className="text-xs text-[#007A8A] font-semibold" data-testid="teacher-cam-status">
          {speaking ? L("Teaching now…", "पढ़ा रही हैं…") : playing ? L("Showing the lesson", "पाठ दिखा रही हैं") : L("Waiting for you", "आपका इंतज़ार कर रही हैं")}
        </div>
        {presence ? (
          <div className="mt-3 flex items-center gap-2 rounded-2xl bg-emerald-50 border border-emerald-200 px-3 py-2 text-xs font-semibold text-emerald-800" data-testid="teacher-cam-present">
            <CheckCircle2 className="w-4 h-4 shrink-0" />{L(`Present · ${fmtClock(presence.at)}`, `उपस्थित · ${fmtClock(presence.at)}`)}
            {presence.total ? <span className="ml-auto text-emerald-700">{L(`${presence.total} ${presence.total === 1 ? "class" : "classes"}`, `${presence.total} क्लास`)}</span> : null}
          </div>
        ) : (
          <div className="mt-3 flex items-center gap-2 rounded-2xl bg-[#F0F4F8] border border-slate-200 px-3 py-2 text-xs text-slate-600" data-testid="teacher-cam-absent">
            <CircleDashed className="w-4 h-4 shrink-0" />{L("Attendance not marked for this lesson", "इस पाठ की attendance अभी नहीं लगी")}
          </div>
        )}
      </div>
    </div>
  );
};
